import { Box } from '@chakra-ui/react';
import { parseAsInteger, useQueryStates } from 'nuqs';
import React, { useTransition } from 'react';

import { MileageType, YearType } from '@/services/filters/new-filters.service';

import { MinMaxFilter } from '../min-max-slider/min-max-slider';
import { NewFilter } from '../new-filter/new-filter';
import { useQueryNonce } from '../utils';
import styles from './new-years-mileage-filter.module.scss';

export const NewYearsMileage: React.FC<{
  years: YearType;
  mileages: MileageType;
  count: number;
}> = ({ years, mileages, count }) => {
  const [_isPending, startTransition] = useTransition();

  const { generate } = useQueryNonce();

  const [_, setQuery] = useQueryStates(
    {
      yearfrom: parseAsInteger,
      yearto: parseAsInteger,
      mileagefrom: parseAsInteger,
      mileageto: parseAsInteger,
    },
    { shallow: false, startTransition },
  );

  return (
    <NewFilter
      label="Years & Mileage"
      count={count}
      onClear={() => {
        setQuery(null);
        generate();
      }}
    >
      <Box className={styles.sliderWrapper}>
        <Box>
          <MinMaxFilter
            min={years.min}
            max={years.max}
            queryKey="year"
            label="Year"
          />
        </Box>
        <Box>
          <MinMaxFilter
            min={mileages.min}
            max={mileages.max}
            queryKey="mileage"
            label="Mileage"
            step={5000}
          />
        </Box>
      </Box>
    </NewFilter>
  );
};
